import { render } from "./sdqzg.vue?vue&type=template&id=698e2c74&scoped=true&ts=true"
import script from "./sdqzg.vue?vue&type=script&lang=ts"
export * from "./sdqzg.vue?vue&type=script&lang=ts"

import "./sdqzg.vue?vue&type=style&index=0&id=698e2c74&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698e2c74"]])

export default __exports__